"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fill: "#1877F2",
  d: "M20.227 12.05A8.227 8.227 0 0 0 12 3.823a8.227 8.227 0 0 0-1.285 16.354v-5.749H8.626V12.05h2.089v-1.813c0-2.062 1.228-3.201 3.108-3.201.9 0 1.842.161 1.842.161v2.024h-1.037c-1.022 0-1.341.634-1.341 1.285v1.543h2.282l-.365 2.378h-1.917v5.749a8.23 8.23 0 0 0 6.942-8.127z"
}), 'Facebook');
